import { render, staticRenderFns } from "./OrdersDetails.vue?vue&type=template&id=234b0f0f&scoped=true&"
import script from "./OrdersDetails.vue?vue&type=script&lang=js&"
export * from "./OrdersDetails.vue?vue&type=script&lang=js&"
import style0 from "./OrdersDetails.vue?vue&type=style&index=0&id=234b0f0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234b0f0f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VContainer,VRow,VSimpleTable})
